<script>
  import { nFormatter } from "./Utils.svelte";

  export let value = "";
  export let append = "";
  export let extra_classes = "";
  export let convert_number = true;
  export let pre_value = "";

  function concat_strings(pre_value, value, append, convert_number) {
    let s = pre_value;
    if (convert_number) {
      s += nFormatter(value);
    } else {
      s += value.toString();
    }
    s += append;

    return s;
  }
</script>

<td nowrap ALIGN="CENTER" style="text-align: center;">
  <div :trim class={extra_classes} style="padding-right: 35px;">
    <!-- {#if value}
      {pre_value}
      {#if convert_number}
        {nFormatter(value)}
      {:else}
        {value}
      {/if}
      {append}
    {/if} -->
    {#if value}
      {concat_strings(pre_value, value, append, convert_number)}
    {/if}
  </div>
</td>

<style>
  td {
    font-size: 14px !important;
    vertical-align: middle;
  }

  .bold {
    font-weight: bold;
  }

  .blue_text {
    color: #4299b0;
  }

  .grey_text {
    color: grey;
  }

  .orange_text {
    color: orange;
  }

  div {
    text-align: right;
    font-size: 14px !important;
  }

  .gruen_ausgefuellt {
    margin-left: 3px;
    margin-right: 3px;
    background-color: #afcb08;
  }

  .grau_ausgefuellt {
    margin-left: 3px;
    margin-right: 3px;
    background-color: #d7e2dc;
  }
</style>
